'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
const ChatOnlyContext = createContext(undefined);
export const ChatOnlyProvider = ({ children }) => {
    const [isChatOnly, setIsChatOnly] = useState(false);
    const value = useMemo(() => ({
        isChatOnly,
        enableChatOnly: () => setIsChatOnly(true),
        disableChatOnly: () => setIsChatOnly(false),
        toggleChatOnly: () => setIsChatOnly((prev) => !prev),
    }), [isChatOnly]);
    return _jsx(ChatOnlyContext.Provider, { value: value, children: children });
};
// Custom hook
export const useChatOnly = () => {
    const context = useContext(ChatOnlyContext);
    if (!context) {
        throw new Error('useChatOnly must be used inside ChatOnlyProvider');
    }
    return context;
};
